<template>
    <div>
        <div class="row">
            <div class="column-main-left">
                <div class="content-container">
                    <div class="header">
                        <div class="title">Reported posts</div>
                        <div class="toggleCleared">
                          <input type="checkbox" v-model="viewCleared">
                          <div class="viewClearedLabel">View Cleared</div>
                        </div>
                    </div>                    
                    <div class="content">
                    </div>
                </div>  
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
              viewCleared: false,
            };
        },
        computed: {
          
        },
        mounted() {
            this.$store.dispatch("breadcrumb", "UtterAccess > Reported posts");
        }
    }
</script>

